import React, {
  createContext,
  useContext,
  type ReactElement,
  type ReactNode,
} from "react";

// NO-775: whether a Healthie transcript newer than the one the draft was made
// from is now current. It comes from the documentation snapshot, while the
// provenance sentence renders deep inside the draft surface, so the workspace
// provides it once instead of threading it through every layer.
const NewerHealthieTranscriptContext = createContext(false);

export function NewerHealthieTranscriptProvider({
  value,
  children,
}: {
  value: boolean;
  children?: ReactNode;
}): ReactElement {
  return (
    <NewerHealthieTranscriptContext.Provider value={value}>
      {children}
    </NewerHealthieTranscriptContext.Provider>
  );
}

export function useNewerHealthieTranscript(): boolean {
  return useContext(NewerHealthieTranscriptContext);
}
